import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userAccessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem("userAccessToken");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Updated API calls - no need to pass user_id
export const getInstances = async () => apiClient.get("/api/instances");

export const createInstance = async (name) =>
  apiClient.post("/api/instances", { name });

export const getAnalytics = () => apiClient.get("/api/instances/analytics");

export const getUserEngagementAnalytics = (params = {}) => {
  return apiClient.get("/api/instances/user-engagement-analytics", { params });
};
